import $ from 'jquery';
import { runProtectedRoute } from '../middleware';
import howtoConfig from '~config/howto.json';
import { colSizes } from '~loader/loader-utils';
import { initPlayYouTubeModal, videoModalId } from '~src/help';

const displayHowToItems = (data) => {
  let howToHtml = '';

  for (const category of data) {
    let categoryHtml = `<div class="row p-4 howto-category mt-5">
      <div class="col-12 mb-3 howto-category-title">
        <h4 class="loader-container-title color-help">
          ${category.categoryName}
        </h4>
        <h6 class="loader-container-sub-title color-help">
            ${category.categoryDescription}          
        </h6>
      </div>`;

    for (const item of category.items) {
      let itemHtml = `<div class="${colSizes['regular']}">
                <div class="howto-item">
                  <div class="howto-item-img-container">`;
      if (item.externalDoc) {
        itemHtml += `
                    <a href="${item.externalDoc}"> <img class="howto-item-img lazy" src="${item.thumbnail}" /></a>`;
      }
      itemHtml += `</div>
                    <div class="howto-item-button-container">`;
      if (item.externalDoc) {
        itemHtml += `
                    <button class="howto-item-button-bottom" id="editor-sidebar-flip-h">
                    <a href="${item.externalDoc}" title="Guida di approfondimento" target="_blank">
                    Guida
                    </a>
                    </button>
                    `;
      }
      if (item.youtubeVideo) {
        itemHtml += `
                        <button class="howto-item-button-bottom help-video" data-toggle="modal" data-target="${videoModalId}" data-youtube-url="${item.youtubeVideo}">
                          Video
                        </button>
                          `;
      }
      itemHtml += `
                      </div>
                </div>
            </div>`;

      categoryHtml += itemHtml;
    }

    categoryHtml += '</div></div>';
    howToHtml += categoryHtml;
  }

  $('#howto-categories-container').append(howToHtml);
};

export const howtoRoute = async () => {
  const ready = await runProtectedRoute();
  if (!ready) return;

  $('#route-howto').show();
  displayHowToItems(howtoConfig);
  initPlayYouTubeModal();
};
